import { createService } from '@bonanza-social/toolkit/api';
import { UploadKYCDocsSchema } from './DocsService.schemas';

export default createService(
  {
    uploadKYCDocs: {
      method: 'POST',
      url: '/kyc',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseSchema: UploadKYCDocsSchema,
    },
  },
  ({ userId }) => `/Docs/${userId}`,
);
